module.exports = __webpack_public_path__ + "img/third-logo.a44e6925.png";